/*
 * Copyright (c) 2024 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Injectable } from '@angular/core';
import { ETransportAddressDTO, ETransportNotificationDTO } from '@well/delivery-libs/etransport/domain-model';
import { EmailablePayloadWithContactsMapDTO } from '@well/domain';

@Injectable({ providedIn: 'root' })
export class ETransportDataAccessUtilService {
  private checkAndSetAddressNull(address: ETransportAddressDTO | null): ETransportAddressDTO | null {
    if (address) {
      const isEmpty = Object.keys(address)
        .filter(
          (key): key is Exclude<keyof ETransportAddressDTO, 'country' | 'uuid' | 'deleted'> =>
            key !== 'country' && key !== 'uuid' && key !== 'deleted'
        )
        .every((key) => address[key] === null || address[key] === '');

      return isEmpty ? null : address;
    }
    return address;
  }

  processAddresses(
    eTransportNotificationWithContacts: EmailablePayloadWithContactsMapDTO<ETransportNotificationDTO>
  ): EmailablePayloadWithContactsMapDTO<ETransportNotificationDTO> {
    const shipmentBaseDTO = eTransportNotificationWithContacts.payload?.eTransportShipmentBaseDTO;

    if (shipmentBaseDTO?.startLocationDTO) {
      shipmentBaseDTO.startLocationDTO.addressDTO = this.checkAndSetAddressNull(
        shipmentBaseDTO.startLocationDTO?.addressDTO
      );
    }

    if (shipmentBaseDTO?.endLocationDTO) {
      shipmentBaseDTO.endLocationDTO.addressDTO = this.checkAndSetAddressNull(
        shipmentBaseDTO.endLocationDTO?.addressDTO
      );
    }

    return eTransportNotificationWithContacts;
  }
}
